import Button from "@pathwright/ui/src/components/button/Button"
import withTranslate from "@pathwright/ui/src/components/lng/withTranslate"
import Pathicon from "@pathwright/ui/src/components/pathicon/Pathicon"
import Text from "@pathwright/ui/src/components/ui/Text"
import classnames from "classnames"
import * as urls from "lib/core/utils/urls"
import React from "react"
import styled from "styled-components"
import "./ResourceHeaderCover.css"

const StyledTrailerPrompt = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  h4 {
    margin-top: 5px;
  }
`

// TODO: image fallback
class ResourceHeaderCover extends React.Component {
  render() {
    const { resource, progress, t } = this.props

    const className = classnames("ResourceHeader__Cover", {
      "ResourceHeader__Cover--Image": resource.resource_type === 10,
      "ResourceHeader__Cover--Badge": resource.resource_type === 20
    })

    return (
      <div className={className}>
        <div className="ResourceHeader__CoverWrapper">
          <img src={resource.thumb_2x} />
          {!!resource.trailer_embed_code && (
            <Button
              className="ResourceHeader__Trailer"
              styleType="blank"
              color="white"
              rounded={false}
              to={urls.modalRoute(`/library/${resource.slug}/about/trailer/`)}
            >
              <StyledTrailerPrompt>
                <Pathicon icon="play" />
                <Text.H4 inverted>{t("Play Course Trailer")}</Text.H4>
              </StyledTrailerPrompt>
            </Button>
          )}
        </div>
      </div>
    )
  }
}

ResourceHeaderCover.displayName = "ResourceHeaderCover"

export default withTranslate(ResourceHeaderCover)
